function About() {
  return (
    <section>
      <h2>About</h2>
      <p>This page explains your app purpose.</p>
    </section>
  );
}

export default About;
